import { render, staticRenderFns } from "./CCoParticipantsQuotation.vue?vue&type=template&id=a4b23ac4&scoped=true&"
import script from "./CCoParticipantsQuotation.vue?vue&type=script&lang=js&"
export * from "./CCoParticipantsQuotation.vue?vue&type=script&lang=js&"
import style0 from "./CCoParticipantsQuotation.vue?vue&type=style&index=0&id=a4b23ac4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4b23ac4",
  null
  
)

export default component.exports